import { Reveal, Overline } from "./Reveal";

export const Vision = () => (
  <section data-testid="vision-section" className="relative overflow-hidden py-28 sm:py-36">
    <span aria-hidden className="text-outline pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 select-none whitespace-nowrap font-display text-[26vw] leading-none opacity-[0.06]">
      1,00,000
    </span>
    <div className="relative mx-auto max-w-4xl px-5 text-center">
      <Reveal>
        <Overline>My Vision for the Future</Overline>
        <h2 className="mt-5 font-heading text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
          A Mission to Mentor <span className="text-peach-dark">1,00,000</span> Individuals
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ink-muted sm:text-lg">
          My goal is to mentor over 1,00,000 individuals — helping them achieve their goals, secure their future,
          and unlock their true potential.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-ink-muted sm:text-lg">
          Every person I mentor becomes part of a larger ripple effect: contributing to the growth of young minds,
          strengthening families, and building a generation that operates from clarity and purpose rather than
          reaction and borrowed patterns.
        </p>
      </Reveal>
    </div>
  </section>
);
